import api from '../api/apiConfig'
import VXETable from 'vxe-table'

export default {
  namespaced: true,
  state: {
    filteredPictureList: [],
    all: []
  },
  mutations: {
    setFilteredList (state, list) {
      state.filteredPictureList = list
    },
    setAll (state, all) {
      state.all = all
    }
  },
  actions: {
    async getImages ({rootState, commit}, condition) {
      commit('setFilteredList', await api.getImages(condition))
    },
    async getAllImages ({rootState, commit}, condition) {
      commit('setAll', await api.getImages(condition))
    },
    async patchImage ({state}, image) {
      await api.patchImage(image)
    },
    async addImage ({state}, {project, image, sourceModel, shotAt, tags}) {
      try {
        const { location } = await api.addImageMeta({project, sourceModel, shotAt, tags})

        await api.addImageContent(location, image)
      } catch (error) {
        await VXETable.modal.alert({ content: '有一張圖片上傳失敗！', status: 'error' })
      }
    },
    async deleteImage ({state}, id) {
      await api.deleteImage(id)
    },
    async getImageTags ({state}) {
      const result = await api.getImageTags()
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/pictureManagement.js